<template>
  <div class="bank-icon">
    <img
      v-if="bankUrl"
      :src="bankUrl"
      :alt="bank"
      class="bank-img"
      width="160"
      height="30"
    >
    <div
      v-else
      class="bank-icon-placeholder"
    >
      {{ bank }}
    </div>
  </div>
</template>

  <script>

export default {
  name        : 'BankIcon',
  inheritAttrs: false,
  props       : {
    bank   : { type: String, required: true, default: '' },
    logoUrl: { type: String, required: false, default: '' }
  },
  computed: {
    slug () {
      return (this.bank || '')
        .toLowerCase()
        .trim()
        .replace(/[^\w]+/g, '-')
        .replace(/(^-|-$)/g, '')
    },
    bankUrl () {
      return this.logoUrl ? this.logoUrl : this.slug ? `/img/banks/${this.slug}.svg` : null
    }
  }
}
  </script>

  <style scoped>
  .bank-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .bank-img {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }
  .bank-icon-placeholder {
    padding: 8px 12px;
    background-color: var(--v-synthesis-ui-grey-05-base, #f5f5f5);
    border: 1px solid var(--v-synthesis-ui-grey-04-base, #e0e0e0);
    border-radius: 4px;
    font-size: 12px;
    color: var(--v-synthesis-ui-grey-01-base, #333);
    text-transform: uppercase;
    font-weight: 500;
  }
  </style>
